document.addEventListener('DOMContentLoaded', function() {
  // Create container for sticky navigation
  const stickyNavContainer = document.createElement('div');
  stickyNavContainer.id = 'StickyNavClone';
  document.body.appendChild(stickyNavContainer);

  // Get the original navigation menu
  const originalNav = document.querySelector('.header__inline-menu');
  if (!originalNav) return;

  // Clone the navigation menu
  const navClone = originalNav.cloneNode(true);
  stickyNavContainer.appendChild(navClone);

  // Add event handlers to clone links
  const cloneLinks = stickyNavContainer.querySelectorAll('a');
  cloneLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      // Prevent default behavior
      e.preventDefault();
      // Get the href attribute
      const href = this.getAttribute('href');
      // Navigate to the href
      if (href) {
        window.location.href = href;
      }
    });
  });

  // Handle dropdown menus in the clone
  const cloneDropdowns = stickyNavContainer.querySelectorAll('details');
  cloneDropdowns.forEach(dropdown => {
    dropdown.addEventListener('toggle', function() {
      if (this.open) {
        // Close all other dropdowns
        cloneDropdowns.forEach(otherDropdown => {
          if (otherDropdown !== this && otherDropdown.open) {
            otherDropdown.removeAttribute('open');
          }
        });
      }
    });
  });

  // Get the position of the original menu
  let navPosition = originalNav.getBoundingClientRect().top + window.scrollY;
  
  // Function to handle scroll
  function handleScroll() {
    if (window.scrollY > navPosition + 50) {
      stickyNavContainer.classList.add('visible');
    } else {
      stickyNavContainer.classList.remove('visible');
      
      // Close any open dropdowns when hiding the sticky menu
      cloneDropdowns.forEach(dropdown => {
        if (dropdown.open) {
          dropdown.removeAttribute('open');
        }
      });
    }
  }
  
  // Add scroll event listener
  window.addEventListener('scroll', handleScroll);
  
  // Handle window resize
  window.addEventListener('resize', function() {
    // Recalculate the position of the original menu
    navPosition = originalNav.getBoundingClientRect().top + window.scrollY;
  });
});